import React from 'react';

const SectionHeader = ({ title, subtitle }) => {
  return (
    <div className="zoho-section-header">
      <h2 className="zoho-section-title">{title}</h2>
      {subtitle && (
        <p className="zoho-section-subtitle">{subtitle}</p>
      )}
    </div>
  );
};

export default SectionHeader;
